import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "chm" }
const _hoisted_2 = { class: "chm-head" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "chm-head-name" }
const _hoisted_6 = { class: "chm-head-phone" }
const _hoisted_7 = { class: "chm-body" }
const _hoisted_8 = {
  key: 0,
  class: "chm-loading"
}
const _hoisted_9 = {
  key: 1,
  class: "chm-error"
}
const _hoisted_10 = {
  key: 2,
  class: "chm-empty"
}
const _hoisted_11 = {
  key: 3,
  class: "chm-list"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "chm-row-left" }
const _hoisted_14 = { class: "chm-row-id" }
const _hoisted_15 = { class: "chm-row-meta" }
const _hoisted_16 = { class: "chm-row-date" }
const _hoisted_17 = {
  key: 0,
  class: "chm-row-team"
}
const _hoisted_18 = { class: "chm-row-center" }
const _hoisted_19 = {
  key: 0,
  class: "chm-row-agent"
}
const _hoisted_20 = {
  key: 1,
  class: "chm-row-labels"
}
const _hoisted_21 = { class: "chm-row-right" }
const _hoisted_22 = { class: "chm-row-dur" }
const _hoisted_23 = {
  key: 0,
  class: "chm-footer"
}

import { ref, onMounted } from 'vue'
import type { Contact, Conversation } from '@/types/dashboard'
import { avatarColor, initials, fmtDuration } from '@/composables/useHelpers'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactHistoryModal',
  props: {
    contact: {},
    accountId: {},
    accessToken: {}
  },
  emits: ["close", "openChat"],
  setup(__props: any) {

const props = __props


const loading = ref(true)
const error   = ref('')
const history = ref<Conversation[]>([])

onMounted(async () => {
  try {
    const res = await fetch(
      `/chatwoot-api/api/v1/accounts/${props.accountId}/contacts/${props.contact.id}/conversations`,
      { headers: { api_access_token: props.accessToken } }
    )
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    const data = await res.json()
    const raw: any[] = data?.payload ?? data ?? []
    history.value = raw
      .map((c: any) => ({
        id:            c.id,
        status:        c.status,
        channel:       c.channel,
        waiting_since: c.meta?.waiting_since ?? 0,
        unread_count:  c.unread_count ?? 0,
        created_at:    c.created_at,
        resolved_at:   c.meta?.resolved_at ?? 0,
        snoozed_until: c.snoozed_until ?? null,
        contact:       {
          id:        c.meta?.sender?.id ?? props.contact.id,
          name:      c.meta?.sender?.name ?? props.contact.name,
          phone:     props.contact.phone,
          thumbnail: c.meta?.sender?.thumbnail ?? props.contact.thumbnail,
        },
        assignee: c.meta?.assignee ? {
          id:           c.meta.assignee.id,
          name:         c.meta.assignee.name,
          email:        c.meta.assignee.email ?? '',
          role:         c.meta.assignee.role ?? 'agent',
          thumbnail:    c.meta.assignee.thumbnail ?? '',
          availability: c.meta.assignee.availability_status ?? 'offline',
        } : null,
        team:    c.meta?.team ? { id: c.meta.team.id, name: c.meta.team.name } : null,
        labels:  Array.isArray(c.labels) ? c.labels : [],
        fluxo_id: c.custom_attributes?.fluxo_id ?? null,
        priority: c.priority ?? null,
        cpf:  c.custom_attributes?.cpf  || null,
        cnpj: c.custom_attributes?.cnpj || null,
      }))
      .sort((a: Conversation, b: Conversation) => b.created_at - a.created_at)
  } catch (e: any) {
    error.value = 'Não foi possível carregar o histórico.'
  } finally {
    loading.value = false
  }
})

function statusLabel(s: string) {
  const map: Record<string, string> = { open: 'Aberta', resolved: 'Resolvida', pending: 'Pendente', snoozed: 'Adiada' }
  return map[s] || s
}

function fmtDate(ts: number) {
  if (!ts) return '—'
  return new Date(ts * 1000).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "chm-backdrop",
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "chm-head-av",
            style: _normalizeStyle({ background: _unref(avatarColor)(__props.contact.name) })
          }, [
            (__props.contact.thumbnail)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: __props.contact.thumbnail,
                  alt: __props.contact.name,
                  onError: _cache[0] || (_cache[0] = (e) => (e.target as HTMLImageElement).style.display='none')
                }, null, 40, _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(initials)(__props.contact.name)), 1))
          ], 4),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.contact.name), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.contact.phone), 1)
          ]),
          _createElementVNode("button", {
            class: "asm-close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
              }),
              _createElementVNode("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
              })
            ], -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "chm-spinner" }, null, -1),
                _createTextVNode(" Carregando histórico… ", -1)
              ]))]))
            : (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(error.value), 1))
              : (!history.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Nenhuma conversa encontrada para este contato."))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(history.value, (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: c.id,
                        class: "chm-row",
                        onClick: ($event: any) => (_ctx.$emit('openChat', c))
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, "#" + _toDisplayString(c.id), 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(fmtDate(c.created_at)), 1),
                            (c.team)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(c.team.name), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          (c.assignee)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                _cache[5] || (_cache[5] = _createElementVNode("svg", {
                                  width: "10",
                                  height: "10",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                                  _createElementVNode("circle", {
                                    cx: "12",
                                    cy: "7",
                                    r: "4"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(c.assignee.name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (c.labels.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.labels.slice(0,3), (l) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: l,
                                    class: "label-chip"
                                  }, _toDisplayString(l.replace(/_/g,' ')), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-pill", c.status]),
                            style: {"font-size":"10px"}
                          }, [
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "sdot" }, null, -1)),
                            _createTextVNode(_toDisplayString(statusLabel(c.status)), 1)
                          ], 2),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(fmtDuration)(c.resolved_at > 0 ? c.resolved_at - c.created_at : (Date.now() / 1000) - c.created_at)), 1)
                        ])
                      ], 8, _hoisted_12))
                    }), 128))
                  ]))
        ]),
        (!loading.value && history.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(history.value.length) + " conversa" + _toDisplayString(history.value.length !== 1 ? 's' : '') + " encontrada" + _toDisplayString(history.value.length !== 1 ? 's' : ''), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})